module.exports = __webpack_public_path__ + "media/35.e3245348.wav";